import(/* webpackMode: "eager" */ "/home/uzouser/front/uzo_2026_front/src/app/global-error.tsx");
